import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { UseCaseFormData } from "../types/use-case.types"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { updateUseCase } from "../api/use-cases-api"

export function useUpdateUseCase() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<UseCaseFormData> }) =>
      updateUseCase(id, data),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.detail(variables.id) })
    },
  })
}
